<template>
    <footer class="footer_section">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-5">
                    <p>3135 Imam Saud Ibn Abdulaziz ibn Mohammed Road King Fahd Dist. Riyadh Gallery Mall, Office 418 Riyadh 12262-7879, Kingdom of Saudi Arabia<br>011-2254009<br><a href="mailto:support@namamedical.org">support@namamedical.org</a></p>
                </div>
                <div class="col-md-3">
                    <h5>Follow us on</h5>
                    <ul class="social_icon">
                        <li><a href="https://twitter.com/nama_medical" target="_blank"><i class="fab fa-twitter"></i></a></li>
                        <li><a href="https://www.instagram.com/namamedical/" target="_blank"><i class="fab fa-instagram"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/nama-medical/" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>                        
                        <li><router-link v-bind:to="'/news/'"><i class="fas fa-newspaper"></i></router-link></li>
                    </ul>
                </div>
                <div class="col-md-4">
                    <newsletter-form></newsletter-form>
                </div>
            </div>
            <p>© {{year}} Nama. All Rights Reserved.
                <router-link v-bind:to="'/privacy-policy/'">Privacy Policy</router-link>
                |
                <router-link v-bind:to="'/terms-and-conditions/'">Terms and Conditions</router-link>
            </p>
        </div>
    </footer>
</template>


<script>
    import BookDemo from './BookDemo'
    import NewsletterForm from './NewsletterForm'
    export default {
        data() {
            return {
                auth: '',
                user: '',
                current_locale:this.$i18n_global.locale,
                year:new Date().getFullYear()
            }
        },
        components:{
            'BookDemo'       :BookDemo,
            'NewsletterForm' :NewsletterForm
        },
        methods:{

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue